import React from 'react';
import Board from './components/Board';
import './components/BoardStyle.css';

const App = () => {
  return (
      <div className="appContainer">
          <Board />
      </div>
  );
}

export default App;